var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',[_vm._v("five hundred")]),_c('p',[_vm._v("You've been served! "),_c('br'),_vm._v("Er, well, no. You haven't. This is a 500 error.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }